import {
  hideLoading,
  sessionExpired,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";

import {
  getUser,
  isLogin,
} from "../Actions/AuthAction";
import Storage from "../../utills/AsyncStorage";
import Axios from "axios";
import { authHeaders, getHeaders, headers, isBase64 } from "../../utills";
import Apis from "../../config/APIs";

export const AuthMiddleware = {
  login: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {

          const data = await Axios.post(
            Apis.login,
            userdata,
          );

          if (data?.status == 200) {
            Storage.setToken(data?.data?.data?.token);
            Storage.setUser("@user", JSON.stringify(data?.data?.data?.user));
            dispatch(getUser(data?.data?.data?.user));
            dispatch(isLogin(true));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  

  logout: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          localStorage.clear();
          dispatch(getUser(null));
          dispatch(isLogin(false));
          dispatch(sessionExpired(false));
          resolve(true);

          // dispatch(isLogin(null))
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Error", message: "Network error" }));
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  onDelUser: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let query = new URLSearchParams();
          query.append("id", userdata?.id);
          const data = await Axios.delete(Apis.del_user(query.toString()), await getHeaders());
          if (data?.status == 200) {
            resolve(true);
            dispatch(showAlert({ message: data?.data?.message, type: "success" }))
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

};
